import { Box, Typography } from '@mui/material'
import { BeoflowButton } from '@/components/BeoflowButton'
import { beoflowColors } from '@/theme/muiTheme'
import { useAuth, exitImpersonation } from '@/contexts/AuthContext'

/**
 * Persistent, non-dismissible banner shown while a support admin is impersonating
 * a user. Truth source is user.impersonated_by (from the token's imp claim), not
 * local state, so it cannot be spoofed or go stale. Peak Orange = alert state.
 */
export default function ImpersonationBanner() {
  const { user } = useAuth()
  const imp = user?.impersonated_by
  if (!imp) return null

  const name = [user?.first_name, user?.last_name].filter(Boolean).join(' ') || user?.email

  return (
    <Box
      role="status"
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 2100,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1,
        px: 2,
        py: 0.25,
        bgcolor: beoflowColors.peakOrange,
      }}
    >
      <Typography variant="caption" sx={{ fontWeight: 700, fontSize: 11, lineHeight: 1.2, color: beoflowColors.beoBlack }}>
        Support session: acting as {name} (via {imp.name})
      </Typography>
      <BeoflowButton
        variant="dark"
        size="small"
        sx={{ minHeight: 20, py: 0.25, px: 1, fontSize: 11, lineHeight: 1.2 }}
        onClick={exitImpersonation}
      >
        Exit
      </BeoflowButton>
    </Box>
  )
}
